import { Component, computed, input } from '@angular/core';
import { formatDatePeriod } from 'src/app/_helpers/utils';

@Component({
  selector: 'app-date-period',
  standalone: true,
  template: `<span>{{ period() }}</span>`,
})
export class DatePeriodComponent {
  startDate = input<Date | undefined>();

  endDate = input<Date | undefined>();

  period = computed(() => formatDatePeriod(this.startDate(), this.endDate()));
}
